<script setup lang="ts">
  defineProps<{
    level: '1' | '2' | '3' | '4' | '5'
    bold?: boolean
  }>()
</script>

<template>
  <h1 v-if="level === '1'" class="text-3xl" :class="bold ? 'font-bold' : 'font-medium'">
    <slot></slot>
  </h1>
  <h2 v-else-if="level === '2'" class="text-2xl" :class="bold ? 'font-bold' : 'font-medium'">
    <slot></slot>
  </h2>
  <h3 v-else-if="level === '3'" class="text-xl" :class="bold ? 'font-bold' : 'font-medium'">
    <slot></slot>
  </h3>
  <h4 v-else-if="level === '4'" class="text-lg" :class="bold ? 'font-bold' : 'font-medium'">
    <slot></slot>
  </h4>
  <h5 v-else-if="level === '5'" class="text-base font-bold">
    <slot></slot>
  </h5>
</template>
